import React from "react";
import Menu, { MenuProps } from "@mui/material/Menu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import {
  COLOR_MENU_DIVIDER,
  COLOR_MENU_HOVER,
  COLOR_MENU_SURFACE,
  COLOR_SHADOW_LIGHT,
  COLOR_TEXT_PRIMARY,
} from "./colors";

export const POPUP_MENU_ITEM_SX = {
  minHeight: "auto",
  padding: "3px 8px",
  borderRadius: "5px",
  fontSize: "14px",
  lineHeight: "20px",
  color: COLOR_TEXT_PRIMARY,
  "&:hover": { backgroundColor: COLOR_MENU_HOVER },
};

export const POPUP_MENU_DIVIDER_SX = {
  margin: "5px 8px !important",
  borderColor: COLOR_MENU_DIVIDER,
};

export const PopupMenuCheck = () => (
  <FontAwesomeIcon icon={faCheck} style={{ width: 12, marginRight: 6 }} />
);

export const PopupMenu: React.FC<
  Pick<
    MenuProps,
    | "open"
    | "onClose"
    | "anchorEl"
    | "anchorOrigin"
    | "transformOrigin"
    | "children"
  > & { paperSx?: object }
> = ({ paperSx, children, ...props }) => (
  <Menu
    {...props}
    disableAutoFocusItem
    slotProps={{
      paper: {
        sx: {
          minWidth: 170,
          maxWidth: 240,
          marginTop: "4px",
          borderRadius: "10px",
          backgroundColor: COLOR_MENU_SURFACE,
          backdropFilter: "blur(20px)",
          boxShadow: `0 0 0 0.5px ${COLOR_SHADOW_LIGHT}, 0 10px 30px rgba(0, 0, 0, 0.16)`,
          ...paperSx,
        },
      },
    }}
    MenuListProps={{ sx: { padding: "5px" } }}
  >
    {children}
  </Menu>
);
